import styled, { css } from 'styled-components';
import { fontFamily } from 'components/styles/_variables';
import { respondTo } from '../../../../styles/_respondTo';

export const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  ${({ isTitle }) =>
    isTitle
      ? css`
          padding: 20px 0 10px 0;
        `
      : css`
          padding: 12px 0;
        `}

  &:after {
    position: absolute;
    width: 100%;
    //background-color: #FF7828;
  }
`;

export const RowItem = styled.div`
  display: flex;
  flex: ${({ flex = 1 }) => flex};
  font-family: ${fontFamily.primary};
  color: #636262;
  justify-content: ${({ justify = 'flex-start' }) => justify};
  align-items: center;
  ${({ title = false }) =>
    title &&
    css`
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
    `}
  ${respondTo.mobile`
    font-size: 14px;
    ${({ hiddenMobile }) =>
      hiddenMobile &&
      css`
        display: none !important;
      `}
  `}
`;

export const Delete = styled.span`
  &:disabled {
    cursor: not-allowed;
    touch-action: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      touch-action: none;
      opacity: 0.75;
    `}
`;
